import React, { useEffect, useState } from 'react';
import { Check, Cookie, Settings2, ShieldCheck, X } from 'lucide-react';

interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
}

const CONSENT_KEY = 'peekpass-cookie-consent';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState<CookiePreferences>({ necessary: true, analytics: false });

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (!localStorage.getItem(CONSENT_KEY)) setIsVisible(true);
    }, 600);
    return () => window.clearTimeout(timer);
  }, []);

  const saveConsent = (nextPreferences: CookiePreferences) => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(nextPreferences));
    localStorage.setItem('peekpass-cookie-consent-date', new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <aside className="fixed bottom-4 right-4 z-[80] w-[calc(100%-2rem)] max-w-md overflow-hidden rounded-2xl border border-[#b9d950] bg-white shadow-[0_28px_70px_-30px_rgba(15,23,42,0.55)]" aria-label="Preferencias de cookies">
      <div className="flex items-start justify-between gap-4 bg-black px-4 py-3 text-white">
        <div className="flex items-center gap-3"><span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#dff38c] text-black"><Cookie className="h-4 w-4" /></span><div><p className="text-sm font-black">PEEK PASS.</p><p className="text-xs text-white/60">Cookies y preferencias</p></div></div>
        <button type="button" onClick={() => saveConsent({ necessary: true, analytics: false })} className="rounded-lg p-1 text-white/70 transition hover:bg-white/10 hover:text-white" aria-label="Cerrar"><X className="h-4 w-4" /></button>
      </div>
      <div className="p-4">
        {!showPreferences ? (
          <>
            <p className="text-sm leading-6 text-slate-600">Usamos cookies esenciales para recordar tu país, tu sesión y tus reservas. Con tu permiso, las analíticas nos ayudan a mejorar la agenda de PEEK PASS.</p>
            <div className="mt-4 grid grid-cols-2 gap-2">
              <button type="button" onClick={() => saveConsent({ necessary: true, analytics: false })} className="rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-xs font-bold text-slate-700 transition hover:border-black">Solo necesarias</button>
              <button type="button" onClick={() => saveConsent({ necessary: true, analytics: true })} className="inline-flex items-center justify-center gap-1.5 rounded-xl bg-black px-3 py-2.5 text-xs font-bold text-white transition hover:bg-slate-800"><Check className="h-4 w-4" />Aceptar</button>
            </div>
            <button type="button" onClick={() => setShowPreferences(true)} className="mt-3 inline-flex items-center gap-2 text-xs font-bold text-[#536d12] underline underline-offset-4"><Settings2 className="h-3.5 w-3.5" />Elegir preferencias</button>
          </>
        ) : (
          <>
            <div className="rounded-xl bg-[#f7fce6] p-3"><div className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-[#536d12]" /><p className="text-xs font-bold text-slate-950">Cookies esenciales</p></div><p className="mt-1 text-xs leading-5 text-slate-600">Siempre activas para que PEEK PASS funcione correctamente.</p></div>
            <button type="button" onClick={() => setPreferences((current) => ({ ...current, analytics: !current.analytics }))} className={`mt-3 flex w-full items-center justify-between rounded-xl border p-3 text-left transition ${preferences.analytics ? 'border-[#b9d950] bg-[#f7fce6]' : 'border-slate-200 bg-white'}`}>
              <span><span className="block text-xs font-bold text-slate-950">Analíticas</span><span className="mt-1 block text-xs text-slate-500">Medición anónima para mejorar la experiencia.</span></span>
              <span className={`flex h-6 w-10 items-center rounded-full p-0.5 transition ${preferences.analytics ? 'justify-end bg-black' : 'justify-start bg-slate-200'}`}><span className="h-5 w-5 rounded-full bg-white shadow-sm" /></span>
            </button>
            <div className="mt-4 grid grid-cols-2 gap-2"><button type="button" onClick={() => setShowPreferences(false)} className="rounded-xl border border-slate-200 px-3 py-2.5 text-xs font-bold text-slate-700">Volver</button><button type="button" onClick={() => saveConsent(preferences)} className="rounded-xl bg-black px-3 py-2.5 text-xs font-bold text-white">Guardar</button></div>
          </>
        )}
      </div>
    </aside>
  );
};

export default CookieBanner;
